"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tgwalletAppName = exports.tgwalletName = exports.tonConnectSdkVersion = exports.shortUniversalLink = exports.standardDeeplink = exports.downloadUrl = exports.standardUniversalLink = exports.okxDeeplink = void 0;
exports.okxDeeplink = 'okx://web3';
exports.standardUniversalLink = typeof window !== "undefined" && window.location.hostname.includes("okx.com")
    ? "https://link.okx.com/download"
    : "https://www.okx.com/download";
exports.downloadUrl = "https://www.okx.com/download";
// export const standardUniversalLink = 'http://localhost:5173';
exports.standardDeeplink = `${exports.okxDeeplink}/wallet/connect`;
exports.shortUniversalLink = `https://www.okx.com/ul/connect`;
// export const standardDeeplink = 'http://localhost:5173';
exports.tonConnectSdkVersion = '1';
// export const tgwalletName: string = "TCTestqdqwdqwdqBot"
exports.tgwalletName = "OKX_WALLET_BOT";
exports.tgwalletAppName = "start";
// https://t.me/OKX_WALLET_BOT/start
